module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Code/Plus-6270c333a6701855c91415e816c1130e.svg";